/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState } from "react";
import ReactJkMusicPlayer from "react-jinke-music-player";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { getCountryList, getGenderList, getIpAddress, getMemberTypeList, getRoles, saveLabel, saveMember } from "../../actions/user";
import "../../assets/scss/components/left-bar.scss";
import { COOKIE_PARAMS } from "../../constants";
import { StoreState } from "../../types/models/store";
import { Actions, checkDateValidation } from "../../utils";
import { LabelModal } from "../modals/label";
import { MemberModal } from "../modals/member";
import "react-jinke-music-player/assets/index.css";
import { Backend } from "shared-types";

export const LeftToolsBar: React.FC = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { selected_tracks } = useSelector((state: StoreState) => state.toolbar);

  const [plusOpen, setPlusOpen] = useState(false);
  const [allOpen, setAllOpen] = useState(false);
  const [analysisOpen, setAnalysisOpen] = useState(false);
  const [showModal, setShowModal] = useState<any>({
    label: false,
    member: false,
  });
  const [ip, setIp] = useState("");
  const [labelModel, setLabelModel] = useState<any>({});
  const [memberModel, setMemberModel] = useState<any>({});
  const [memberTypeList, setMemberTypeList] = useState<any>([]);
  const [audioList, setAudioList] = useState<any>([]);
  const [playerActive, setPlayerActive] = useState<boolean>(false);
  const [genderList, setGenderList] = useState<any>([]);
  const [countryList, setCountryList] = useState<any>([]);
  const [roleList, setRoleList] = useState<Backend.T_MemberRole[]>([]);

  useEffect(() => {
    getMemberTypeList({}).then((res: any) => {
      setMemberTypeList(res.result);
    });
    getGenderList({}).then((res: any) => {
      setGenderList(res.result);
    });
    getCountryList({}).then((res: any) => {
      setCountryList(res?.countries);
    });
    getRoles().then((res: any) => {
      setRoleList(res)
    })
  }, []);


  const wrapperRef: any = useRef(null);

  useEffect(() => {
    function handleClickOutside(event: any) {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        setAllOpen(false);
        setPlusOpen(false);
        setAnalysisOpen(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [wrapperRef]);

  useEffect(() => {
    getIpAddress()
      .then((res) => setIp(res))
      .catch(console.warn);

    let old = window.localStorage.getItem(COOKIE_PARAMS.SELECTED.TRACK);
    let arr = JSON.parse(old ? old : "[]");
    dispatch({
      type: "SET_SELECTED_TRACKS",
      payload: arr,
    });
  }, []);

  useEffect(() => {
    window.localStorage.setItem(
      COOKIE_PARAMS.SELECTED.TRACK,
      JSON.stringify(selected_tracks)
    );
    setAudioList(
      selected_tracks?.map((track: any) => ({
        name: track.title,
        singer: track.singer,
        cover: track.cover,
        musicSrc: `https://prelistening.cugate.com/?i=${track.file}`,
        lyric: "lyric",
      }))
    );
  }, [selected_tracks]);

  const handleLabelAddAction = () => {
    setLabelModel({
      id: 0,
      validate: true,
      title: "",
      alias: "",
      comments: "",
      action: Actions.add,
      message: "",
    });
    setShowModal({ ...showModal, label: true });
  };

  const handleLabelSaveAction = async (event: {
    currentTarget: any;
    preventDefault: () => void;
    stopPropagation: () => void;
  }) => {
    const form = event.currentTarget;
    event.preventDefault();
    if (form.checkValidity() === false) {
      event.stopPropagation();
      setLabelModel({ ...labelModel, validate: false, message: "" });
    } else {
      setLabelModel({ ...labelModel, validate: true, message: "" });
      saveLabel({
        ...labelModel,
        action:
          labelModel.action === Actions.add
            ? "add"
            : labelModel.action === Actions.edit
              ? "edit"
              : "delete",
        client_id: 2,
      }).then((res: any) => {
        if (res.result.status) {
          setLabelModel({
            ...labelModel,
            title: res.result.status === 2 ? "" : labelModel.title,
            alias: res.result.status === 1 ? "" : labelModel.alias,
            message: res.result.message,
            validate: true,
          });
        } else {
          if (labelModel.action === Actions.add) {
            dispatch({
              type: "SET_ADDED_STATUS",
              payload: "label",
            });
          }
          setShowModal({ ...showModal, label: false });
        }
      });
    }
  };

  const handleMemberAddAction = (standard_role_id: number = 43) => {
    setMemberModel({
      id: 0,
      validate: true,
      title: "",
      alias: "",
      used_name: 1,
      member_type_id: 1,
      standard_role_id: standard_role_id,
      gender_id: 1,
      tag_status_id: 1,
      // birth_date: "",
      // death_date: "",
      member_url: "",
      // worktime_from: "",
      // worktime_to: "",

      // genre_id: "",
      // birth_country_id: "",
      birth_place: "",
      // birth_place_latitude: "",
      // birth_place_longitude: "",
      // death_country_id: "",
      death_place: "",
      // death_place_latitude: "",
      // death_place_longitude: "",
      img_path: "http://img.cugate.com",
      img_34: 0,
      img_64: 0,
      img_174: 0,
      img_300: 0,
      img_600: 0,
      img_orgn: 0,
      bio_url: "",
      fan_url: "",
      merch_url: "",
      trash_status: 0,
      register_from: 2,
      duplicate_group_id: 0,

      register_ip: ip,
      avatar: "",
      action: Actions.add,
      message: "",
    });
    setShowModal({ ...showModal, member: true });
  };

  const handleReleaseAddAction = () => {
    navigate("/release/new");
  };

  const handleReleaseOverviewAction = () => {
    navigate("/release-overview");
  };

  const handleMemberSaveAction = async (event: {
    currentTarget: any;
    preventDefault: () => void;
    stopPropagation: () => void;
  }) => {
    const form = event.currentTarget;
    event.preventDefault();
    // eslint-disable-next-line no-mixed-operators
    const dateValidationMessage = checkDateValidation(
      memberModel.birth_date,
      memberModel.death_date
    );

    if (
      form.checkValidity() === false ||
      ((memberModel.avatar === null || memberModel.avatar === "") &&
        memberModel.action === Actions.add) || dateValidationMessage
    ) {
      event.stopPropagation();
      setMemberModel({
        ...memberModel, validate: false,
        message: dateValidationMessage || "Invalid form data. Please check the fields.",
      });
    } else {
      setMemberModel({ ...memberModel, validate: true, message: "" });
      saveMember({
        ...memberModel,
        action:
          memberModel.action === Actions.add
            ? "add"
            : memberModel.action === Actions.edit
              ? "edit"
              : "delete",
      }).then((res: any) => {
        if (res.result.status) {
          setMemberModel({
            ...memberModel,
            message: res.result.message,
            validate: true,
          });
        } else {
          if (memberModel.action === Actions.add) {
            dispatch({
              type: "SET_ADDED_STATUS",
              payload:
                memberModel.standard_role_id === 43 ? "artist" : "composer",
            });
          }
          setShowModal({ ...showModal, member: false });
        }
      });
    }
  };

  const handleCloseModal = () => {
    setShowModal({
      label: false,
      artist: false,
      composer: false,
    });
  };

  const playTracksAction = () => {
    setPlayerActive(!playerActive);
  };

  const handleLeftToolBar = (selectedMenu: string, event: any) => {
    switch (selectedMenu) {
      case 'first':
        setAllOpen(!allOpen);
        setPlusOpen(false);
        setAnalysisOpen(false);
        break;
      case 'second':
        setAllOpen(false);
        setPlusOpen(!plusOpen);
        setAnalysisOpen(false);
        break;
      case 'third':
        setAllOpen(false);
        setPlusOpen(false);
        setAnalysisOpen(!analysisOpen);
        break;
    }
  }

  return (
    <div className="left-tools-bar" ref={wrapperRef}>
      <ul>
        {selected_tracks.length ? (
          <li onClick={() => playTracksAction()} id="audioPlayer">
            <svg
              width="29"
              height="25"
              viewBox="0 0 29 25"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M28.8003 17.1C28.8003 16.2 28.1003 15.4 27.2003 15.2V10.9C27.2003 5.19998 21.6003 0.599976 14.8003 0.599976C8.00029 0.599976 2.40029 5.19998 2.40029 10.9V15.2C1.40029 15.5 0.800293 16.2 0.800293 17.1V21.2C0.800293 22.3 1.90029 23.3 3.30029 23.3H4.30029C4.60029 24.1 5.60029 24.7 6.60029 24.7H6.70029C8.10029 24.7 9.20029 23.8 9.20029 22.6V15.8C9.20029 14.7 8.10029 13.7 6.70029 13.7H6.60029C5.50029 13.7 4.60029 14.3 4.30029 15.1H4.20029V10.9C4.20029 10.6 4.20029 10.2 4.30029 9.89997C4.70029 10.1 5.10029 10.2 5.60029 10.2C6.60029 10.2 7.60029 9.69997 7.90029 8.79997C8.90029 6.29997 11.8003 4.69998 14.9003 4.69998C18.1003 4.69998 20.9003 6.39997 21.9003 8.79997C22.2003 9.59997 23.2003 10.2 24.2003 10.2C24.7003 10.2 25.1003 10.1 25.5003 9.89997C25.5003 10.2 25.6003 10.6 25.6003 10.9V15H25.5003C25.2003 14.2 24.2003 13.6 23.2003 13.6H23.0003C21.6003 13.6 20.5003 14.5 20.5003 15.7V22.5C20.5003 23.6 21.6003 24.6 23.0003 24.6H23.2003C24.3003 24.6 25.2003 24 25.5003 23.2H26.5003C27.9003 23.2 29.0003 22.3 29.0003 21.1V17.1H28.8003Z"
                fill="white"
              />
            </svg>
          </li>
        ) : (
          ""
        )}
        <li
          // onMouseEnter={() => setAllOpen(true)}
          // onMouseLeave={() => setAllOpen(false)}
          // onTouchStart={() => setAllOpen(true)}
          // onTouchEnd={() => setAllOpen(false)}
          onClick={(e) => handleLeftToolBar('first', e)}
          className={allOpen ? "active" : ""}
        >
          <svg
            width="29"
            height="29"
            viewBox="0 0 29 29"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M10.8003 9.59996H12.4003C12.4003 7.89996 12.6003 5.89996 11.1003 4.39996C10.6003 3.89996 10.1003 3.49996 9.70029 3.19996C8.60029 2.29996 8.20029 1.89996 8.20029 0.899963H6.60029V13C6.00029 12.6 5.30029 12.4 4.50029 12.4C2.50029 12.4 0.800293 14.1 0.800293 16.1C0.800293 18.1 2.50029 19.8 4.50029 19.8C6.60029 19.8 8.20029 18.1 8.20029 16V3.99996C8.70029 4.49996 9.30029 4.89996 9.90029 5.49996C11.0003 6.59996 10.8003 7.99996 10.8003 9.59996Z"
              fill="white"
            />
            <path
              d="M14.8005 9.39998V22.2C14.2005 21.8 13.5005 21.6 12.7005 21.6C10.7005 21.6 9.00049 23.3 9.00049 25.3C9.00049 27.3 10.7005 29 12.7005 29C14.7005 29 16.4005 27.3 16.4005 25.3V13.9C19.1005 13.4 24.5005 12.3 27.2005 11.8V18.9C26.6005 18.5 25.9005 18.3 25.1005 18.3C23.1005 18.3 21.4005 20 21.4005 22C21.4005 24 23.1005 25.7 25.1005 25.7C27.1005 25.7 28.8005 24 28.8005 22C28.8005 21.1 28.8005 7.29998 28.8005 6.59998L14.8005 9.39998Z"
              fill="white"
            />
          </svg>
          <ul className={`${allOpen ? "d-block" : "d-none"}`}>
            <li>
              <Link
                to={`/all-releases`}
                className="tw-w-full tw-h-full tw-text-center tw-text-white hover:!tw-text-white tw-py-3"
              >
                All Releases
              </Link>
            </li>
            <li>
              <Link
                to={`/all-members`}
                className="tw-w-full tw-h-full tw-text-center tw-text-white hover:!tw-text-white tw-py-3"
              >
                All Artists
              </Link>
            </li>
            <li>
              <Link
                to={`/all-tracks`}
                className="tw-w-full tw-h-full tw-text-center tw-text-white hover:!tw-text-white tw-py-3"
              >
                All Tracks
              </Link>
            </li>
          </ul>
        </li>

        <li
          // onMouseEnter={() => setPlusOpen(true)}
          // onMouseLeave={() => setPlusOpen(false)}
          // onTouchStart={() => setPlusOpen(true)}
          // onTouchEnd={() => setPlusOpen(false)}
          onClick={(e) => handleLeftToolBar('second', e)}
          className={plusOpen ? "active" : ""}
        >
          <svg
            width="29"
            height="29"
            viewBox="0 0 29 29"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M14.8003 0.399963C11.1003 0.399963 7.50029 1.89997 4.90029 4.49997C2.30029 7.09997 0.800293 10.7 0.800293 14.4C0.800293 18.1 2.30029 21.7 4.90029 24.3C7.50029 26.9 11.1003 28.4 14.8003 28.4C18.5003 28.4 22.1003 26.9 24.7003 24.3C27.3003 21.7 28.8003 18.1 28.8003 14.4C28.8003 10.7 27.3003 7.09997 24.7003 4.49997C22.1003 1.79997 18.6003 0.399963 14.8003 0.399963ZM22.0003 13C22.8003 13 23.4003 13.6 23.4003 14.4C23.4003 14.8 23.2003 15.1 23.0003 15.4C22.8003 15.6 22.4003 15.8 22.0003 15.8H16.2003V21.6C16.2003 22 16.0003 22.3 15.8003 22.6C15.6003 22.8 15.2003 23 14.8003 23C14.0003 23 13.4003 22.4 13.4003 21.6V15.8H7.60029C6.80029 15.8 6.20029 15.2 6.20029 14.4C6.20029 13.6 6.80029 13 7.60029 13H13.4003V7.19997C13.4003 6.39997 14.0003 5.79997 14.8003 5.79997C15.6003 5.79997 16.2003 6.39997 16.2003 7.19997V13H22.0003Z"
              fill="white"
            />
          </svg>
          <ul className={`${plusOpen ? "d-block" : "d-none"}`}>
            <li onClick={handleLabelAddAction}>Add Label</li>
            <li onClick={() => handleMemberAddAction(43)}>Add Artist</li>
            <li onClick={() => handleMemberAddAction(13)}>Add Composer</li>
            <li>
              <Link
                to={`/track/new`}
                className="tw-w-full tw-h-full tw-text-center tw-text-white hover:!tw-text-white tw-py-3"
              >
                Add Track
              </Link>
            </li>
            <li onClick={handleReleaseOverviewAction}>Add Release</li>
            {/* <li onClick={handleReleaseAddAction}>Add Release</li> */}
            {/* <li onClick={handleReleaseOverviewAction}>Release Overview</li> */}
          </ul>
        </li>
        <li
          // onMouseEnter={() => setAnalysisOpen(true)}
          // onMouseLeave={() => setAnalysisOpen(false)}
          // onTouchStart={() => setAnalysisOpen(true)}
          // onTouchEnd={() => setAnalysisOpen(false)}
          onClick={(e) => handleLeftToolBar('third', e)}
          className={analysisOpen ? "active" : ""}
        >
          <svg
            width="29"
            height="29"
            viewBox="0 0 29 29"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path d="M6.58282 13.1H0.582825V22.4H6.58282V13.1Z" fill="white" />
            <path
              d="M28.5828 0.599976H22.5828V22.4H28.5828V0.599976Z"
              fill="white"
            />
            <path
              d="M17.5828 6.79999H11.5828V28.6H17.5828V6.79999Z"
              fill="white"
            />
          </svg>
          <ul className={`${analysisOpen ? "d-block" : "d-none"}`}>
            <li>
              <Link
                to={`https://reports-cutrack-front-end-test-pagination.onrender.com/dashboard`}
                className="tw-w-full tw-h-full tw-text-center tw-text-white hover:!tw-text-white tw-py-3"
                target="_blank"
              >
                Analysis
              </Link>
            </li>
          </ul>
        </li>
      </ul>
      <LabelModal
        mkey={"label-add"}
        show={showModal.label}
        model={labelModel}
        setModel={setLabelModel}
        closeModal={handleCloseModal}
        saveModal={handleLabelSaveAction}
      />
      <MemberModal
        mkey={"member-add"}
        show={showModal.member}
        model={memberModel}
        setModel={setMemberModel}
        closeModal={handleCloseModal}
        memberTypeList={memberTypeList}
        saveModal={handleMemberSaveAction}
        genderList={genderList}
        countryList={countryList}
        roleList={roleList}
      />
      {playerActive ? (
        <ReactJkMusicPlayer
          className={playerActive ? "active" : ""}
          audioLists={audioList}
          mode={"full"}
          // getContainer={() => { return document.getElementById('audioPlayer') || document.body }}
          toggleMode={false}
          showDownload={false}
          showThemeSwitch={false}
          autoPlay={false}
          glassBg={true}
          showMediaSession={true}
          quietUpdate={false}
          clearPriorAudioLists={true}
          remove={false}
          onPlayIndexChange={(index) => {
            console.log(`selected: ${index}`);
          }}
        />
      ) : (
        <></>
      )}
    </div>
  );
};

export default LeftToolsBar;
